import { render, staticRenderFns } from "./TermsOfUsePage.vue?vue&type=template&id=83dce5d8&scoped=true"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=js"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUsePage.vue?vue&type=style&index=0&id=83dce5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dce5d8",
  null
  
)

export default component.exports